import React, { Component } from 'react';

export default class Loading extends Component {
  render() {
    return (
      <p className="text-center">Loading...</p>
    )
  }
};
